import type { Node } from '@squaredup/graph';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useRef } from 'react';

export const useObjectTableVirtualizer = (objects: Node[] | undefined, hasNextObjectsPage: boolean) => {
    const tableScrollRef = useRef<HTMLDivElement>(null);

    const currentObjectsCount = objects?.length ?? 0;
    const rowVirtualizer = useVirtualizer({
        count: hasNextObjectsPage ? currentObjectsCount + 1 : currentObjectsCount,
        overscan: 25,
        getScrollElement: () => tableScrollRef.current,
        estimateSize: () => 25 // Height of each row in px
    });

    return { rowVirtualizer, tableScrollRef };
};
